import FetchArticles from "./components/FetchArticles"

function App() {
  return (
    <>
      <FetchArticles />
    </>
  )
}

export default App
